export const API_BASE_URL = import.meta.env.VITE_API_URL || '';

export const POLLING_INTERVALS = [
  { value: 60, label: '1 minute' },
  { value: 300, label: '5 minutes' },
  { value: 900, label: '15 minutes' },
  { value: 1800, label: '30 minutes' },
  { value: 3600, label: '1 hour' },
] as const;

export const NODE_STATES = {
  ALIVE: 'ALIVE',
  UNREACHABLE: 'UNREACHABLE',
} as const;

export const PROFILE_TYPES = ['Edge', 'Cloud Connector', 'Virtual Edge'] as const;

export const LIFECYCLE_STATES = {
  online: { label: 'Online', color: 'dls-bg-status-online', textColor: 'dls-text-white' },
  offline: { label: 'Offline', color: 'dls-bg-status-offline', textColor: 'dls-text-white' },
  new: { label: 'New', color: 'dls-bg-status-info', textColor: 'dls-text-white' },
  recentlyCommissioned: {
    label: 'Recently Commissioned',
    color: 'dls-bg-neeve-tertiary',
    textColor: 'dls-text-white',
  },
} as const;

export const COMMISSIONED_PERIOD_OPTIONS = [
  { value: 7, label: '7 days' },
  { value: 14, label: '14 days' },
  { value: 30, label: '30 days' },
  { value: 90, label: '90 days' },
] as const;

export const NETWORK_TYPES = ['STATIC', 'DYNAMIC', 'WAN'] as const;

export const SEGMENTS = [
  'BMS',
  'Camera',
  'Voice',
  'WAN',
  'VLAN',
  'Guest',
  'IoT',
  'Other',
] as const;

export const TUNNEL_STATES = {
  connected: { label: 'Connected', color: 'dls-text-status-online' },
  disconnected: { label: 'Disconnected', color: 'dls-text-status-offline' },
  unknown: { label: 'Unknown', color: 'dls-text-status-warning' },
} as const;
